import axios from 'axios';
import { logout, refreshToken } from '../store/slices/userSlice';
import { useDispatch } from 'react-redux';
import { create } from './services';

// Create an Axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Replace with your API URL

});

// Request Interceptor
api.interceptors.request.use(
  (config) => {
    // Add Authorization token if available
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // console.log('Request:', config);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
const excludedRoutes = ['/auth/login', '/auth/register', '/auth/refresh-token'];
// Response Interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response) {
      const originalRequest = error.config;
      
      // Handle 401 Unauthorized (token expired)
      if (error.response.status === 401 && !originalRequest._retry  && !excludedRoutes.some(route => originalRequest.url?.includes(route))) {
        originalRequest._retry = true;
        const token = localStorage.getItem('token');
        const refreshToken = localStorage.getItem('refreshToken');
        // console.log('hereeee')
        if (refreshToken) {
          try {
            // Call your refresh token endpoint
            const response = await api.post('/auth/refresh-token', { 
              refreshToken: refreshToken 
            });
            
            const { token: newToken, refreshToken: newRefreshToken } = response.data;
            
            // Update tokens in storage
            localStorage.setItem('token', newToken);
            localStorage.setItem('refreshToken', newRefreshToken);
            
            // Update the Authorization header
            api.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
            originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
            
            // Retry the original request
            return api(originalRequest);
          } catch (refreshError) {
            // If refresh token fails, clear storage and redirect to login
            // localStorage.removeItem('token');
            localStorage.removeItem('refreshToken');
             window.location.href = '/login';
            return Promise.reject(refreshError);
          }
        } else {
          // No refresh token available, redirect to login
          //  window.location.href = '/login';
          return Promise.reject(error);
        }
      }
      
      // Handle 403 Forbidden
      if (error.response.status === 403) {
        // console.log('Forbidden! You do not have permission.');
        // Optionally redirect or show a message
      }
    } else if (error.request) {
      console.log('No response from server.');
    } else {
      console.log('Request error:', error.message);
    }
    
    return Promise.reject(error);
  }
);

export default api;
